import { render, staticRenderFns } from "./EnacAtplDashboardNotificationOthers.vue?vue&type=template&id=58f3452c"
import script from "./EnacAtplDashboardNotificationOthers.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardNotificationOthers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports